<div class="restrictions-table rt-table-wrap" [class.rt-tab]="tabLayout" [class.rt-default-sort]="isDefaultSort" [hidden]="totalCount === 0 && (tabLayout || loaded)">
  <mat-table [dataSource]="dataSource" class="rt-table" matSort matSortActive="company.name" matSortDirection="asc">

    <!-- Company Column -->
    <ng-container matColumnDef="company.name">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="w-restrict-md"
                       [ngClass]="{
                       active: sort?.active === 'company.name',
                       descending: sort?.active === 'company.name' && sort?.direction === 'desc'
                       }">
        Company
      </mat-header-cell>
      <mat-cell *matCellDef="let boardSeat" class="w-restrict-md">
        <div>
          <a href="/company/{{ boardSeat.company.id }}?tab=restrictions" target="_blank" class="rt-key">{{ boardSeat.company.name }}</a>
          <span class="rt-sub">{{ getCompanyLine(boardSeat) }}</span>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Ticker Column -->
    <ng-container matColumnDef="company.ticker">
      <mat-header-cell *matHeaderCellDef class="w-restrict-xs">Ticker</mat-header-cell>
      <mat-cell *matCellDef="let boardSeat" class="w-restrict-xs">{{ boardSeat.company.ticker }}</mat-cell>
    </ng-container>

    <!-- Representing Column -->
    <ng-container matColumnDef="representing">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="w-restrict-sm"
                       [ngClass]="{
                       active: sort?.active === 'representing',
                       descending: sort?.active === 'representing' && sort?.direction === 'desc'
                       }">Representing</mat-header-cell>
      <mat-cell *matCellDef="let boardSeat" class="w-restrict-sm">
        {{ BoardSeatRepresentingLabels[boardSeat.representing] }}
      </mat-cell>
    </ng-container>

    <!-- Person Column -->
    <ng-container matColumnDef="person.lastName">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="w-restrict-md"
                       [ngClass]="{
                       active: sort?.active === 'person.lastName',
                       descending: sort?.active === 'person.lastName' && sort?.direction === 'desc'
                       }">Person</mat-header-cell>
      <mat-cell *matCellDef="let boardSeat" class="w-restrict-md">
        <div>
          <span [class.rt-key]="tabLayout"><ng-container *ngTemplateOutlet="personName; context: { $implicit: boardSeat }"></ng-container></span>
          <span class="rt-sub" *ngIf="boardSeat.representing">{{ BoardSeatRepresentingLabels[boardSeat.representing] }}</span>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Internal Position Column -->
    <ng-container matColumnDef="companyPosition">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="w-restrict-sm"
                       [ngClass]="{
                       active: sort?.active === 'companyPosition',
                       descending: sort?.active === 'companyPosition' && sort?.direction === 'desc'
                       }">Int. Position</mat-header-cell>
      <mat-cell *matCellDef="let boardSeat" class="w-restrict-sm">
        {{ boardSeat.companyPosition }}
      </mat-cell>
    </ng-container>

    <!-- Current Position Column -->
    <ng-container matColumnDef="company.isPrivate">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="w-restrict-sm"
                       [ngClass]="{
                       active: sort?.active === 'company.isPrivate',
                       descending: sort?.active === 'company.isPrivate' && sort?.direction === 'desc'
                       }">Cur. Position</mat-header-cell>
      <mat-cell *matCellDef="let boardSeat" class="w-restrict-sm">
        {{ boardSeat.company.isPrivate ? 'Private' : 'Public' }}
      </mat-cell>
    </ng-container>

    <!-- Board Role Column -->
    <ng-container matColumnDef="boardRole">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="w-restrict-sm"
                       [ngClass]="{
                       active: sort?.active === 'boardRole',
                       descending: sort?.active === 'boardRole' && sort?.direction === 'desc'
                       }">Role</mat-header-cell>
      <mat-cell *matCellDef="let boardSeat" class="w-restrict-sm">
        <div>
          {{ boardSeat.boardRole }}
          <span class="rt-sub rt-wrap" *ngIf="boardSeat.committees">{{ boardSeat.committees }}</span>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Committees Column -->
    <ng-container matColumnDef="committees">
      <mat-header-cell *matHeaderCellDef class="w-restrict-sm">Committee(s)</mat-header-cell>
      <mat-cell *matCellDef="let boardSeat" class="w-restrict-sm">{{ boardSeat.committees }}</mat-cell>
    </ng-container>

    <!-- Start Date Column -->
    <ng-container matColumnDef="startDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="w-restrict-sm"
                       [ngClass]="{
                       active: sort?.active === 'startDate',
                       descending: sort?.active === 'startDate' && sort?.direction === 'desc'
                       }">{{ tabLayout ? 'Since' : 'Start' }}</mat-header-cell>
      <mat-cell *matCellDef="let boardSeat" class="w-restrict-sm">
        <div>
          <span *ngIf="boardSeat.startDate" class="rt-date">{{ boardSeat.startDate.toFormat(CONFIG.restrictionDateFormat) }}</span>
          <span class="rt-sub rt-resignation" *ngIf="boardSeat.resignationSentDate">Resignation sent {{ boardSeat.resignationSentDate.toFormat(CONFIG.restrictionDateFormat) }}</span>
        </div>
      </mat-cell>
    </ng-container>

    <!-- End Date Column -->
    <ng-container matColumnDef="endDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="w-restrict-sm"
                       [ngClass]="{
                       active: sort?.active === 'endDate',
                       descending: sort?.active === 'endDate' && sort?.direction === 'desc'
                       }">End</mat-header-cell>
      <mat-cell *matCellDef="let boardSeat" class="w-restrict-sm">
        <span *ngIf="boardSeat.endDate" class="rt-date">{{ boardSeat.endDate.toFormat(CONFIG.restrictionDateFormat) }}</span>
      </mat-cell>
    </ng-container>

    <!-- Resignation Sent Date Column -->
    <ng-container matColumnDef="resignationSentDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="w-restrict-sm"
                       [ngClass]="{
                       active: sort?.active === 'resignationSentDate',
                       descending: sort?.active === 'resignationSentDate' && sort?.direction === 'desc'
                       }">Resg. Sent</mat-header-cell>
      <mat-cell *matCellDef="let boardSeat" class="w-restrict-sm">
        <span *ngIf="boardSeat.resignationSentDate" class="rt-date">{{ boardSeat.resignationSentDate.toFormat(CONFIG.restrictionDateFormat) }}</span>
      </mat-cell>
    </ng-container>

    <!-- Contact Column -->
    <ng-container matColumnDef="contact">
      <mat-header-cell *matHeaderCellDef class="w-restrict-md">Contact</mat-header-cell>
      <mat-cell *matCellDef="let boardSeat" class="w-restrict-md">
        <div>
          <div>{{ boardSeat.contactPerson }}</div>
          <div *ngIf="boardSeat.contactEmail">({{ boardSeat.contactEmail }})</div>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Last Modified Column -->
    <ng-container matColumnDef="lastModified">
      <mat-header-cell *matHeaderCellDef mat-sort-header="updated" class="w-restrict-lg"
                       [ngClass]="{
                       active: sort?.active === 'updated',
                       descending: sort?.active === 'updated' && sort?.direction === 'desc'
                       }">Last Modified</mat-header-cell>
      <mat-cell *matCellDef="let boardSeat" class="w-restrict-lg rt-modified-cell">
        <div>
          <div class="rt-nowrap">{{ boardSeat.lastModifiedBy?.fullName }}</div>
          <span class="rt-sub" *ngIf="boardSeat.lastModified">{{ boardSeat.lastModified.toFormat(CONFIG.restrictionDateTimeFormat) }}</span>
        </div>
        <ng-container *ngTemplateOutlet="rowActions; context: { $implicit: boardSeat }"></ng-container>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let boardSeat; columns: displayedColumns" class="data-row"
             [class.inactive-row]="!boardSeat.active"></mat-row>
  </mat-table>
</div>

<!-- The tab's narrow layout: one card per record, switched on from the tab column's width (see _restrictions.scss) -->
<div class="rt-cards" *ngIf="tabLayout && totalCount > 0" role="list">
  <div class="rt-card" role="listitem" *ngFor="let boardSeat of records">
    <div class="rt-card-title">
      <span class="rt-key"><ng-container *ngTemplateOutlet="personName; context: { $implicit: boardSeat }"></ng-container></span>
    </div>
    <div class="rt-card-facts">
      <ng-container *ngIf="boardSeat.representing">{{ BoardSeatRepresentingLabels[boardSeat.representing] }}</ng-container>
      <ng-container *ngIf="boardSeat.boardRole"><span class="rt-sep" *ngIf="boardSeat.representing"> · </span>{{ boardSeat.boardRole }}</ng-container>
      <ng-container *ngIf="boardSeat.startDate">
        <span class="rt-sep" *ngIf="boardSeat.representing || boardSeat.boardRole"> · </span>Since {{ boardSeat.startDate.toFormat(CONFIG.restrictionDateFormat) }}
      </ng-container>
    </div>
    <div class="rt-card-body" *ngIf="boardSeat.committees || boardSeat.resignationSentDate">
      <div *ngIf="boardSeat.committees">{{ boardSeat.committees }}</div>
      <div class="rt-resignation" *ngIf="boardSeat.resignationSentDate">Resignation sent {{ boardSeat.resignationSentDate.toFormat(CONFIG.restrictionDateFormat) }}</div>
    </div>
    <div class="rt-card-secondary" *ngIf="boardSeat.contactPerson || boardSeat.contactEmail">
      <span class="rt-card-label">Contact</span>{{ boardSeat.contactPerson }}<ng-container *ngIf="boardSeat.contactEmail"> ({{ boardSeat.contactEmail }})</ng-container>
    </div>
    <div class="rt-card-secondary" *ngIf="boardSeat.companyPosition">
      <span class="rt-card-label">Int. Position</span>{{ boardSeat.companyPosition }}
    </div>
    <div class="rt-card-meta">
      {{ boardSeat.lastModifiedBy?.fullName }}<ng-container *ngIf="boardSeat.lastModified"><span class="rt-sep"> · </span>{{ boardSeat.lastModified.toFormat(CONFIG.restrictionDateTimeFormat) }}</ng-container>
    </div>
    <ng-container *ngTemplateOutlet="rowActions; context: { $implicit: boardSeat }"></ng-container>
  </div>
</div>

<div class="d-flex justify-content-end mb-2 rt-pager" *ngIf="showPager">
  <rms-pagination [pagination]="pagination"
                  [totalRecords]="totalCount"
                  (onPageChanged)="onPageChange()"
                  (onRecordsPerPageChanged)="onPageChange()"
  ></rms-pagination>
</div>

<rms-board-seat-add-edit></rms-board-seat-add-edit>
<rms-delete-confirmation></rms-delete-confirmation>
<rms-confirmation-modal #updateFailConfirm></rms-confirmation-modal>

<!-- Person links to the Restrictions page's person filter; the tab doesn't filter, so it's plain text there -->
<ng-template #personName let-boardSeat>
  <a *ngIf="!tabLayout; else personText" href="javascript:void(0)" (click)="personClick.next(boardSeat.person)">
    {{ boardSeat.person?.fullName }}<span *ngIf="!boardSeat.person?.active" class="inactive-label"> (inactive)</span>
  </a>
  <ng-template #personText>
    {{ boardSeat.person?.fullName }}<span *ngIf="!boardSeat.person?.active" class="inactive-label"> (inactive)</span>
  </ng-template>
</ng-template>

<ng-template #rowActions let-boardSeat>
  <button type="button" class="rms-row-kebab" *ngIf="hasRowActions(boardSeat)"
          [matMenuTriggerFor]="rowMenu" [matMenuTriggerData]="{ boardSeat: boardSeat }"
          aria-label="Board seat actions" title="Actions">
    <svg width="3" height="13" viewBox="0 0 3 15" fill="none" aria-hidden="true">
      <circle cx="1.5" cy="1.5" r="1.5" fill="currentColor"/>
      <circle cx="1.5" cy="7.5" r="1.5" fill="currentColor"/>
      <circle cx="1.5" cy="13.5" r="1.5" fill="currentColor"/>
    </svg>
  </button>
</ng-template>

<mat-menu #rowMenu="matMenu" xPosition="before" class="rms-row-menu-panel">
  <ng-template matMenuContent let-boardSeat="boardSeat">
    <button mat-menu-item type="button" *ngIf="canEdit()" [disabled]="spinnerService.active"
            (click)="openBoardSeatAddEdit(boardSeat)">
      <i class="fa fa-pencil" aria-hidden="true"></i><span>Edit</span>
    </button>
    <button mat-menu-item type="button" class="rms-row-menu-danger" *ngIf="canDelete(boardSeat)" [disabled]="spinnerService.active"
            (click)="deleteBoardSeat(boardSeat)">
      <i class="fa fa-times-circle" aria-hidden="true"></i><span>Delete</span>
    </button>
  </ng-template>
</mat-menu>

<!-- The header row as a native row, rendered by the Restrictions page into its pinned copy on phones -->
<ng-template #pinnedHeadRow>
  <tr>
    <th *ngFor="let column of displayedColumns" [ngClass]="columnClass(column)"
        [class.active]="isSortedBy(column)" [class.descending]="isSortedBy(column) && sort.direction === 'desc'"
        [class.rt-sortable]="isSortable(column)" [class.rt-sorted-fill]="isSortedBy(column) && !isDefaultSort"
        scope="col" (click)="sortFromPin(column)" (keydown.enter)="sortFromPin(column)">{{ columnLabel(column) }}</th>
  </tr>
</ng-template>
